import { refresh } from 'aos';
import { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// import Worker from 'worker-loader!./tokenRefreshWorker';

function useRefreshToken() {
  const workerRef = useRef(null);
  const dispatch = useDispatch();
  const storedData = useSelector((state) => state.storedData.payload);
  // const tokenRef = useRef(localStorage.getItem('token'));
  // const refreshTokenRef = useRef(localStorage.getItem('refreshToken'));

  useEffect(() => {
    // Check to see if token is expired
    /*
     *  Applicable in 2 scenarios
     *  1. When user closes the tab and re-opens. We will check if token is valid
     *  before making any calls.
     *  2. If computer is put into sleep and re-opened, when the tab opens
     *  will check if token is valid before any other action.
     *
     * */
    checkTokenExpiration();

    // Initialize the Web Worker
    workerRef.current = new Worker(`${process.env.PUBLIC_URL}/workers/tokenRefreshWorker.js`);
    // console.log('## New worker created', workerRef.current);

    // Send message to start the worker
    workerRef.current.postMessage({
      type: 'start',
      url: `${process.env.REACT_APP_API_URL}/users/refreshtoken`,
      token: localStorage.getItem('token'),
      refreshToken: localStorage.getItem('refreshToken'),
      // token: tokenRef.current,
      // refreshToken: refreshTokenRef.current,
    });

    // Listen for messages from the worker
    workerRef.current.onmessage = (event) => {
      const { type, token, refreshToken, expirationTime } = event.data;

      // To logout due to user inactivity
      if (type === 'logout') {
        logout();
      } else if (type === 'updateTokens') {
        // console.log('##Inside update tokens');

        // tokenRef.current = token;
        // refreshTokenRef.current = refreshToken;

        localStorage.setItem('token', token);
        localStorage.setItem('refreshToken', refreshToken);
        localStorage.setItem('ptTokenExpiration', expirationTime);
        let obj = { ...storedData, token: token, refreshToken: refreshToken };
        dispatch({ type: 'LOCAL_STORE_DATA', payload: obj });
      }
    };

    // Cleanup worker 
    return () => {
      if (workerRef.current) {
        workerRef.current.terminate();
      }
    };
  }, []);

  // Handle user activity and notify the worker
  useEffect(() => {
    const handleUserActivity = () => {
      localStorage.setItem('lastActiveTime', new Date().valueOf());

      if (workerRef.current) {
        workerRef.current.postMessage({ type: 'userActivity' });
      }
    };

    /*
     * Below function listen for localStorage update 
     * to keep track of activities across different tabs
     * 
     * This will ensure logout (interval) is cleared in all tabs for activity
     * in any tab
     * */
    const handleLastActiveTimeUpdate = (e) => {
      if (e.key === 'lastActiveTime') {
        workerRef.current.postMessage({ type: 'userActivity' });
      }
    }

    // Add event listeners for user activity
    window.addEventListener('keydown', handleUserActivity);
    window.addEventListener('mousedown', handleUserActivity);
    window.addEventListener('touchstart', handleUserActivity);

    // Event listener to detect changes to localStorage
    window.addEventListener('storage', handleLastActiveTimeUpdate);

    // Cleanup event listeners on unmount
    return () => {
      window.removeEventListener('keydown', handleUserActivity);
      window.removeEventListener('mousedown', handleUserActivity);
      window.removeEventListener('touchstart', handleUserActivity);
      window.removeEventListener('storage', handleLastActiveTimeUpdate);
    };
  }, []);
}

const checkTokenExpiration = () => {
  const expirationTime = localStorage.getItem('ptTokenExpiration');
  const currentTime = new Date().valueOf();

  if (expirationTime && currentTime > parseInt(expirationTime, 10)) {
    logout();
  }
}

const logout = () => {
  localStorage.clear();
  sessionStorage.clear();
  window.location.href = '/sign-in'; // Redirect to sign-in page
}

export default useRefreshToken;
